import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@tanstack/react-router";
import logo from "@/assets/logo-clara-camille.png";

const pageLinks = [
  { label: "Início", href: "/" },
  { label: "Sobre mim", href: "/sobre" },
  { label: "Consulta online", href: "/consulta-nutricional-online-australia" },
  { label: "Acompanhamento", href: "/acompanhamento-nutricional-australia" },
  { label: "Primeira consulta", href: "/consulta-inicial-gratuita" },
  { label: "Blog", href: "/blog" },
  { label: "Contato", href: "/contato" },
];

const guiasLinks = [
  { label: "Alimentação na Austrália", href: "/guia-alimentacao-brasileiros-australia" },
  { label: "Emagrecer na Austrália", href: "/como-emagrecer-morando-na-australia" },
  { label: "Hospitality", href: "/alimentacao-saudavel-hospitality-australia" },
  { label: "Estudantes", href: "/dieta-estudantes-brasileiros-australia" },
  { label: "Mercado australiano", href: "/mercado-australiano-o-que-comprar" },
];

const atendimentoLinks = [
  { label: "Brisbane (presencial)", href: "/nutricionista-brasileira-brisbane" },
  { label: "Sydney (online)", href: "/nutricionista-brasileira-sydney" },
  { label: "Melbourne (online)", href: "/nutricionista-brasileira-melbourne" },
  { label: "Toda a Austrália", href: "/nutricionista-brasileira-na-australia" },
  { label: "In English", href: "/portuguese-speaking-nutritionist-brisbane" },
];

const legalLinks = [
  { label: "Política de Privacidade", href: "/politica-de-privacidade" },
  { label: "Termos de Uso", href: "/termos" },
];

const Footer = () => {
  return (
    <footer className="bg-[hsl(30,20%,88%)] text-foreground py-10 sm:py-14">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-2 md:grid-cols-5 gap-8 sm:gap-10 mb-8 sm:mb-10">
          {/* Brand + Instagram */}
          <div className="space-y-4 sm:space-y-5 sm:col-span-2 md:col-span-1">
            <img src={logo} alt="Clara Camille" className="h-20 sm:h-24 w-auto" width={177} height={140} />
            <p className="text-sm leading-relaxed text-muted-foreground">
              Nutricionista brasileira na Austrália. Acompanhamento nutricional personalizado para quem quer cuidar da saúde mesmo longe do Brasil.
            </p>
            <a
              href="https://www.instagram.com/nutriclaracamille_/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 rounded-2xl px-4 sm:px-5 py-3 w-fit transition-all hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, hsl(330, 70%, 55%), hsl(30, 90%, 55%), hsl(50, 95%, 60%))',
                boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
              }}
            >
              <Instagram className="h-5 w-5 text-white" />
              <span className="text-white font-semibold text-sm">@nutriclaracamille_</span>
            </a>
          </div>

          {/* Páginas */}
          <div className="space-y-3">
            <h3 className="text-foreground font-semibold font-sans text-sm uppercase tracking-wider">Páginas</h3>
            <ul className="space-y-2">
              {pageLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div className="space-y-3">
            <h3 className="text-foreground font-semibold font-sans text-sm uppercase tracking-wider">Contato</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://wa.me/61423038977" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
                  <Phone className="h-4 w-4" /> 0423 038 977
                </a>
              </li>
              <li>
                <a href="mailto:nutriclaracamille@gmail.com" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
                  <Mail className="h-4 w-4" /> nutriclaracamille@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/place/?q=place_id:ChIJP4oYHOVZkWsRVe1_7AfKZT8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                  <span>8 Harbour Rd, Hamilton QLD 4007<br />Brisbane, Austrália</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Guias */}
          <div className="space-y-3">
            <h3 className="text-foreground font-semibold font-sans text-sm uppercase tracking-wider">Guias</h3>
            <ul className="space-y-2">
              {guiasLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Atendimento */}
          <div className="space-y-3">
            <h3 className="text-foreground font-semibold font-sans text-sm uppercase tracking-wider">Atendimento</h3>
            <ul className="space-y-2">
              {atendimentoLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground/15 pt-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Clara Camille. Todos os direitos reservados.</span>
          {legalLinks.map((link) => (
            <Link key={link.href} to={link.href} className="hover:text-foreground transition-colors">
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
